import React, { Component } from 'react'

class Loader extends Component {
    render() {
        return (
            <div className="loader">
                <div className="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        );
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js